import { primitive } from './primitive';

export const semantic = {
  text: {
    primary: primitive.gray[900],
    secondary: primitive.gray[700],
    caption: primitive.gray[500],
    disabled: primitive.gray[300],
    inverse: primitive.gray[0],
    accent: primitive.blue[700],
    'accent-strong': primitive.blue[900],
    success: primitive.green[900],
    warning: primitive.orange[900],
    error: primitive.red[900]
  },
  icon: {
    primary: primitive.gray[900],
    secondary: primitive.gray[700],
    tertiary: primitive.gray[500],
    quaternary: primitive.gray[300],
    disabled: primitive.gray[200],
    inverse: primitive.gray[0],
    accent: primitive.blue[700],
    success: primitive.green[700],
    warning: primitive.orange[700],
    error: primitive.red[700]
  },
  divider: {
    primary: primitive.blue[200],
    secondary: primitive.blue[300]
  },
  border: {
    primary: primitive.blue[700],
    'primary-hover': primitive.blue[900],
    secondary: primitive.gray[200],
    'secondary-hover': primitive.gray[500],
    tertiary: primitive.blue[300],
    inverse: primitive.gray[0],
    disabled: primitive.gray[200],
    success: primitive.green[700],
    warning: primitive.orange[700],
    error: primitive.red[700]
  },
  background: {
    base: primitive.gray[0],
    'base-hover': primitive.blue[100],
    primary: primitive.blue[700],
    'primary-hover': primitive.blue[900],
    secondary: primitive.blue[200],
    'secondary-hover': primitive.blue[300],
    tertiary: primitive.blue[100],
    unread: primitive.blue[50],
    inverse: primitive.gray[700],
    disabled: primitive.gray[100],
    'disabled-strong': primitive.gray[200],
    'success-primary': primitive.green[700],
    'success-primary-hover': primitive.green[900],
    'success-secondary': primitive.green[100],
    'success-secondary-hover': primitive.green[200],
    'warning-primary': primitive.orange[700],
    'warning-primary-hover': primitive.orange[900],
    'warning-secondary': primitive.orange[100],
    'warning-secondary-hover': primitive.orange[200],
    'error-primary': primitive.red[700],
    'error-primary-hover': primitive.red[900],
    'error-secondary': primitive.red[100],
    'error-secondary-hover': primitive.red[200]
  }
} as const;
